import { render, staticRenderFns } from "./AdminPodDashboard.vue?vue&type=template&id=02387960&scoped=true&"
import script from "./AdminPodDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminPodDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminPodDashboard.vue?vue&type=style&index=0&id=02387960&prod&scoped=true&lang=css&"
import style1 from "./AdminPodDashboard.vue?vue&type=style&index=1&id=02387960&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02387960",
  null
  
)

export default component.exports